module.exports = __webpack_public_path__ + "img/二维码_深圳科技.a31f2c46.png";